import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Footer from '../../Components/Footer/Footer';
import Header from '../../Components/Header/Header';
import CurrentSubs from '../../Components/Profile/CurrentSubs';
import ProfileTab from '../../Components/Profile/ProfileTabs';
import ChangePackageOption from './ChangePackageOption';
import SubscriptionOption from './SubscriptionOption';

const   UpdateSubscription = () => {
    const [subscriptionOption, setSubscriptionOption] = useState(1);
    const ReduxPackage = useSelector((state) => state?.Auth?.activePackage);
    let navigate = useNavigate();
    const SetHandleClick = (e) => {
        setSubscriptionOption(e);
    }

    const CheckPackages = () => {
        if (!ReduxPackage) {
            // navigate('/packages');
            console.log("no work")
        }
    }

    useEffect(() => {
        CheckPackages();
    }, [])

    return (
        <div>
            <section className='profile my_subscription'>
                <Header />
                <div className='container px-4'>
                    <div className='row'>
                        <div className='col-lg-12 text-center'>
                            <p className='f-pop-bold f-43 mb-5 mt-3'>My Profile</p>
                        </div>
                        <div className='col-lg-4'>
                            <ProfileTab />
                        </div>
                        <div className='col-lg-8 px-5 mb-5 res-pxx'>
                            < ChangePackageOption />
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </div>
    )
}

export default UpdateSubscription;